import Experience from '../../Experience.js'
import * as THREE from 'three'

export default class Weather {
    constructor()
    {
        // Setup
        this.experience = new Experience()
        this.resources = this.experience.loader.items
        this.scene = this.experience.scene
        this.time = this.experience.time

        // Instantiate Method
        this.createSnow()
    }

    // Instantiate Method
    createSnow()
    {
        const particlesCount = 6000

        this.createPositions(particlesCount)

        // Geometry
        const geometry = new THREE.BufferGeometry()
        geometry.setAttribute(
            'position',
            new THREE.BufferAttribute(this.positions, 3)
        )

        // Material
        const material = new THREE.PointsMaterial({
            color: '#ffffff',
            map: this.resources.snowTexture,
            transparent: true,
            depthWrite: false,
            size: 0.3,    // 0.1
            sizeAttenuation: true
        })

        // Points
        this.group1 = new THREE.Points(geometry, material)
        this.group2 = new THREE.Points(geometry, material)
        this.group2.position.y = 80
        this.scene.add(this.group1, this.group2)
    }

    // Animate Snow
    update()
    {
        const delta = this.time.delta * 0.001
        this.rain(delta)
        this.galaxy(delta)
    }

    // Helper Methods
    createPositions(count)
    {
        this.positions = new Float32Array(count * 3)

        for(let i = 0; i < count; i++)
        {
            this.positions[i * 3 + 0] = (Math.random() - 0.5) * 50
            this.positions[i * 3 + 1] = (Math.random() - 0.5) * 160
            this.positions[i * 3 + 2] = (Math.random() - 0.5) * 50
        }
    }

    rain(time)
    {
        this.group1.position.y -= time * 1.8
        this.group2.position.y -= time * 1.8
    
        const maxDistance = - (70)
        if(this.group1.position.y < maxDistance)
        {
            this.group1.position.y = 80
        }
        else if(this.group2.position.y < maxDistance)
        {
            this.group2.position.y = 80
        }
    }

    galaxy(time)
    {
        this.group1.rotation.y += time * 0.1
        this.group2.rotation.y -= time * 0.1
    }
}